module.exports = __webpack_public_path__ + "img/16_26@2x.980e2170.png";